// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pre-relative{color:#3f80fe;font-size:14px;text-decoration:none}", ""]);
// Exports
module.exports = exports;
